var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        [
          _c(
            "span",
            { attrs: { slot: "label" }, slot: "label" },
            [
              _vm._v(" 获取经纬度 "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    content:
                      "开启后将在位置后面增加经纬度属性（longitude,latitude）",
                    effect: "dark",
                    placement: "top-start",
                  },
                },
                [_c("i", { staticClass: "el-icon-question" })]
              ),
            ],
            1
          ),
          _c("el-switch", {
            model: {
              value: _vm.activeData.longAndLat,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "longAndLat", $$v)
              },
              expression: "activeData.longAndLat",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "span",
            { attrs: { slot: "label" }, slot: "label" },
            [
              _vm._v(" 开启选点 "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    content: "开启后展示地图，支持手动选择位置",
                    effect: "dark",
                    placement: "top-start",
                  },
                },
                [_c("i", { staticClass: "el-icon-question" })]
              ),
            ],
            1
          ),
          _c("el-switch", {
            model: {
              value: _vm.activeData.selectLocation,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "selectLocation", $$v)
              },
              expression: "activeData.selectLocation",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "span",
            { attrs: { slot: "label" }, slot: "label" },
            [
              _vm._v(" 禁用搜索 "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    content: "默认开启搜索，关闭后搜索框禁用",
                    effect: "dark",
                    placement: "top-start",
                  },
                },
                [_c("i", { staticClass: "el-icon-question" })]
              ),
            ],
            1
          ),
          _c("el-switch", {
            model: {
              value: _vm.activeData.showSerachInput,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "showSerachInput", $$v)
              },
              expression: "activeData.showSerachInput",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }